import React from "react"
import { replaceUTF8Codes } from "../utilities"
import { withPrefix } from "gatsby"

const DfbBreadcrumbs = (props) => {
  if (props.pageData && props.pageData.parentData)
    return (
      <nav className="dfb-Breadcrumb m-Opener-breadcrumb">
        <ol className="dfb-Breadcrumb-list">
          <li className="dfb-Breadcrumb-item" data-item={0}>
            <a
              className="dfb-Breadcrumb-link"
              href={withPrefix(props.pageData.parentData.full_slug)}
            >
              {props.pageData.parentData.name}
            </a>
          </li>
          <li className="dfb-Breadcrumb-item is-active" data-item={1}>
            <a
              className="dfb-Breadcrumb-link"
              href={withPrefix(props.pageData.full_slug)}
            >
              {replaceUTF8Codes(props.pageData.name)}
            </a>
          </li>
        </ol>
      </nav>
    )
}
export default DfbBreadcrumbs
